/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateTableColumn } from './FormulaEvaluateTableColumn';
import {
    FormulaEvaluateTableColumnFromJSON,
    FormulaEvaluateTableColumnFromJSONTyped,
    FormulaEvaluateTableColumnToJSON,
    FormulaEvaluateTableColumnToJSONTyped,
} from './FormulaEvaluateTableColumn';
import type { FormulaEvaluateColumnDataType } from './FormulaEvaluateColumnDataType';
import {
    FormulaEvaluateColumnDataTypeFromJSON,
    FormulaEvaluateColumnDataTypeFromJSONTyped,
    FormulaEvaluateColumnDataTypeToJSON,
    FormulaEvaluateColumnDataTypeToJSONTyped,
} from './FormulaEvaluateColumnDataType';

/**
 * 
 * @export
 * @interface FormulaEvaluateResultSpec
 */
export interface FormulaEvaluateResultSpec {
    /**
     * 
     */
    tables?: { [key: string]: Array<FormulaEvaluateTableColumn>; } | null;
    /**
     * 
     */
    values?: { [key: string]: FormulaEvaluateColumnDataType; } | null;
}

/**
 * Check if a given object implements the FormulaEvaluateResultSpec interface.
 */
export function instanceOfFormulaEvaluateResultSpec(value: object): value is FormulaEvaluateResultSpec {
    return true;
}

export function FormulaEvaluateResultSpecFromJSON(json: any): FormulaEvaluateResultSpec {
    return FormulaEvaluateResultSpecFromJSONTyped(json, false);
}

export function FormulaEvaluateResultSpecFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateResultSpec {
    if (json == null) {
        return json;
    }
    return {
        
        'tables': json['tables'] === undefined ? undefined : json['tables'] === null ? null : json['tables'],
        'values': json['values'] === undefined ? undefined : json['values'] === null ? null : (mapValues(json['values'], FormulaEvaluateColumnDataTypeFromJSON)),
    };
}

export function FormulaEvaluateResultSpecToJSON(json: any): FormulaEvaluateResultSpec {
    return FormulaEvaluateResultSpecToJSONTyped(json, false);
}

export function FormulaEvaluateResultSpecToJSONTyped(value?: FormulaEvaluateResultSpec | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tables': value['tables'],
        'values': value['values'] == null ? undefined : (mapValues(value['values'], FormulaEvaluateColumnDataTypeToJSON)),
    };
}

